const LocaleGrid = () => import(/* webpackChunkName: "LocaleGrid" */ './locale/containers/LocaleGrid');
const TagGrid = () => import(/* webpackChunkName: "LocaleGrid" */ './tag/containers/TagGrid');

export const configurationRouting = [
    {path: '/configuration/locale', name: 'locale-list', component: LocaleGrid},
    {path: '/configuration/tag', name: 'tag-list', component: TagGrid},
]
